import { lazy } from 'react'

export const accountLoadables = {
	LoadableAccount: lazy(() => import('../containers/Account/index')),
	LoadableNsi: lazy(() => import('../containers/NRI/index')),
	LoadableNsiModify: lazy(() => import('../containers/NRI/nriModify/index'))
}
